import slideStyle from "./InfoPage.module.scss";
import pricingStyles from "./Pricing.module.scss";
import ContactAppendix from "./ContactAppendix";
import classNames from "classnames";
import { getMessage, Message, MessageContext } from "@messageformat/react";
import { useContext } from "react";

import appStyle from "../App.module.scss";

const Pricing = () => {
  const messageContext = useContext(MessageContext);

  return (
    <div className={slideStyle.section}>
      <div className={slideStyle.heading}>
        <div style={{ margin: "40px 0" }}>
          <div className={appStyle.heading}>
            <span>
              <Message id="infoPages.pricing.subtitle" />
            </span>
            <h2>
              <Message id="infoPages.pricing.title" />
            </h2>
          </div>
        </div>

        <div className={slideStyle.benefit}>
          <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.benefits.incomes")() }} />
          <div>
            <img
              src={require("./profits/money-count.png")}
              alt="Wzrost zysków"
            />
          </div>
        </div>

        <div className={classNames(slideStyle.benefit, slideStyle.benefitRev)}>
          <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.benefits.simplicity")() }} />
          <div>
            <img
              src={require("./profits/intuitive.png")}
              alt="Prosty w użytkowaniu"
            />
          </div>
        </div>

        <div className={slideStyle.benefit}>
          <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.benefits.realtime")() }} />
          <div>
            <img
              src={require("./profits/results.png")}
              alt="Dane w czasie rzeczywistym"
            />
          </div>
        </div>

        <div className={classNames(slideStyle.benefit, slideStyle.benefitRev)}>
          <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.benefits.lessBreakdowns")() }} />
          <div>
            <img src={require("./profits/peace.png")} alt="Pokój w duchu" />
          </div>
        </div>

        <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.suitableForYou")() }} />

        {/* <ComparisonTable /> */}

        <div>
          <div className={pricingStyles.priceDisplay}>
            99 PLN
          </div>
          <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.pricing.minimalPlan")() }} />
        </div>

        <ContactAppendix />
      </div>
    </div>
  );
};

export default Pricing;
